import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CompanyUserManagement from '../components/admin/CompanyUserManagement';
import '../styles/AdminPage.css';

const CompanyAdminPage = () => {
  const { isAuthenticated, isCompanyAdminOrAbove } = useAuth();
  if (!isAuthenticated || !isCompanyAdminOrAbove()) {
    return <Navigate to="/" replace />;
  }
  return (
    <div className="page admin-page">
      <h1>管理</h1>
      <div className="admin-sections">
        <CompanyUserManagement />
      </div>
    </div>
  );
};

export default CompanyAdminPage;
